export const transitAgency = [
  { key: 'KCM', text: 'King County Metro Transit', value: 'KCM' },
  { key: 'KIT', text: 'Kitsap Transit', value: 'KIT' },
  { key: 'COM', text: 'Community Transit', value: 'COM' },
  { key: 'ISL', text: 'Island Transit', value: 'ISL' },
  { key: 'EVE', text: 'Everett Transit', value: 'EVE' },
  { key: 'JEF', text: 'Jefferson Transit', value: 'JEF' },
  { key: 'SKA', text: 'Skagit Transit', value: 'SKA' },
  { key: 'MSN', text: 'Mason Transit', value: 'MSN' },
  { key: 'PVT', text: 'Private Vanpool', value: 'PVT' }
];